import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import DueToday from '../../common/MiniCart/funComp/desktopCart/dueToday';
import { checkIsMidnight } from '../../common/Helpers';

const MCartDueToday = (props) => {
  useEffect(() => {
    if (checkIsMidnight()) {
      props.updateShowCart(true);
    }
  }, []);

  return <DueToday {...props} showCartStatus={(iscartVisibleVal) => props.showCart(iscartVisibleVal)} />;
};

export default MCartDueToday;

MCartDueToday.propTypes = {
  showCart: PropTypes.func,
  updateShowCart: PropTypes.func,
};
